import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const BackOrderIcon = ({ size = 28, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Cubo Oro dritto e minimale */}
      <rect
        x="12"
        y="12"
        width="40"
        height="40"
        rx="6"
        fill={GOLD}
      />

      {/* Nastro/Dettaglio verticale Grigio */}
      <rect
        x="26"
        y="12"
        width="12"
        height="20"
        fill={GRAY}
      />

      {/* Dettaglio orizzontale Grigio (sigillo pacco) */}
      
    </svg>
  );
};

export default BackOrderIcon;